export class SettlementCard {
    currency: string;
    amounts: AmountPerDay[];
}
export class AmountPerDay {
    amount: string;
    date: string;
}
